import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "disabled", "placeholder"]
const _hoisted_3 = ["id", "name", "type", "disabled", "placeholder"]
const _hoisted_4 = {
  key: 2,
  class: "error-message"
}

import { PropType } from 'vue';
import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';
import { useVModel } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-text-input',
},
  __name: 'text-input',
  props: {
  id: {
    type: String,
  },
  type: {
    type: String as PropType<'text' | 'email' | 'password' | 'search'>,
    default: 'text',
  },
  label: {
    type: String,
  },
  name: {
    type: String,
  },
  modelValue: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
  },
  errorMessage: {
    type: String,
  },
  multiline: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hideLabel: {
    type: Boolean,
  },
},
  emits: ["update:modelValue", "change"],
  setup(__props, { emit: __emit }) {



const props = __props;

const { inputId } = useIdGenerator(props.id);

const emit = __emit;

const value = useVModel(props, 'modelValue', emit);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-input", { 'has-error': __props.errorMessage }])
  }, [
    _createElementVNode("label", {
      for: _unref(inputId),
      class: _normalizeClass({ 'sr-only': __props.hideLabel })
    }, _toDisplayString(__props.label), 11, _hoisted_1),
    (__props.multiline)
      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 0,
          class: "control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
          id: _unref(inputId),
          name: __props.name,
          disabled: __props.disabled,
          placeholder: __props.placeholder,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('change', _unref(value))))
        }, null, 40, _hoisted_2)), [
          [_vModelText, _unref(value)]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          class: "control",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
          id: _unref(inputId),
          name: __props.name,
          type: __props.type,
          disabled: __props.disabled,
          placeholder: __props.placeholder,
          onChange: _cache[3] || (_cache[3] = ($event: any) => (emit('change', _unref(value))))
        }, null, 40, _hoisted_3)), [
          [_vModelDynamic, _unref(value)]
        ]),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})